import {
  ExperimentFeature,
  GetAllExperimentsOptedOutResponse,
} from '@fullstory/proto/fs/services/orgs';

export const EXPERIMENT_RESPONSE: GetAllExperimentsOptedOutResponse = {
  optOuts: [
    {
      feature: ExperimentFeature.FEATURE_SESSION_SUMMARY,
      optedOut: false,
    },
    {
      feature: ExperimentFeature.FEATURE_SELECTOR_TRIM,
      optedOut: false,
    },
    {
      feature: ExperimentFeature.FEATURE_SUGGESTED_ELEMENTS,
      optedOut: false,
    },
  ],
};
